// src/app/shared/swiper-init.service.ts

import { Injectable } from '@angular/core';

declare var $: any;
declare var Swiper: any;

@Injectable({
  providedIn: 'root',
})
export class SwiperInitService {
  initSliders(): void {
    setTimeout(() => {
      if ($('.th-slider').length) {
        $('.th-slider').each(function () {
          const thSlider = $(this);
          const settingsAttr = thSlider.attr('data-slider-options');
          let settings = {};

          try {
            settings = settingsAttr ? JSON.parse(settingsAttr) : {};
          } catch (e) {
            console.error('Invalid JSON in data-slider-options:', settingsAttr);
          }

          const prevArrow = thSlider.find('.slider-prev');
          const nextArrow = thSlider.find('.slider-next');
          const paginationElN = thSlider.find('.slider-pagination.pagi-number');
          const paginationExternel = thSlider.siblings('.slider-controller').find('.slider-pagination');
          const paginationEl = paginationExternel.length
            ? paginationExternel.get(0)
            : thSlider.find('.slider-pagination').get(0);

          const paginationType = settings['paginationType'] || 'bullets';
          const autoplayCondition = settings['autoplay'];

          const sliderDefault = {
            slidesPerView: 1,
            spaceBetween: settings['spaceBetween'] || 24,
            loop: settings['loop'] !== false,
            speed: settings['speed'] || 1000,
            autoplay: autoplayCondition || {
              delay: 6000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: nextArrow.get(0),
              prevEl: prevArrow.get(0),
            },
            pagination: {
              el: paginationEl,
              type: paginationType,
              clickable: true,
              renderBullet: function (index: number, className: string) {
                const number = index + 1;
                const formatted = number < 10 ? '0' + number : number;
                if (paginationElN.length) {
                  return `<span class="${className} number">${formatted}</span>`;
                } else {
                  return `<span class="${className}" aria-label="Go to Slide ${formatted}"></span>`;
                }
              },
              formatFractionCurrent: (number: number) => (number < 10 ? '0' + number : number),
              formatFractionTotal: (number: number) => (number < 10 ? '0' + number : number),
            },
            on: {
              slideChange: function () {
                setTimeout(() => {
                  // @ts-ignore
                  this.params.mousewheel.releaseOnEdges = false;
                }, 500);
              },
              reachEnd: function () {
                setTimeout(() => {
                  // @ts-ignore
                  this.params.mousewheel.releaseOnEdges = true;
                }, 750);
              },
            },
          };

          const finalOptions = $.extend({}, sliderDefault, settings);
          const swiper = new Swiper(thSlider.get(0), finalOptions);

          // Add styling class if required
          if ($('.slider-area').length > 0) {
            $('.slider-area').closest('.container').parent().addClass('arrow-wrap');
          }

          // Category slider special animation
          if (thSlider.hasClass('categorySlider')) {
            const multiplier = {
              translate: 0.1,
              rotate: 0.008,
            };

            const calculateWheel = () => {
              const slides = document.querySelectorAll('.single');
              slides.forEach((slide: HTMLElement) => {
                const rect = slide.getBoundingClientRect();
                const r = window.innerWidth * 0.5 - (rect.x + rect.width * 0.5);
                let ty = Math.abs(r) * multiplier.translate - rect.width * multiplier.translate;
                ty = Math.max(ty, 0);

                const transformOrigin = r < 0 ? 'left top' : 'right top';
                slide.style.transform = `translate(0, ${ty}px) rotate(${-r * multiplier.rotate}deg)`;
                slide.style.transformOrigin = transformOrigin;
              });
            };

            const raf = () => {
              requestAnimationFrame(raf);
              calculateWheel();
            };

            raf();
          }
        });
      }
    }, 0);
  }
}
